import { QuestionPreviewType } from "mobx-store/storeInterfaces/surveyInterface";
import { FacilityDTO } from "./facilityDTO";
import { FacilityFormViewModel } from "./facilityFormViewModel";

const facilityToDTO = (formViewModel: FacilityFormViewModel): FacilityDTO => {
  const {
    id,
    availableCountries,
    title,
    questions,
    deletedQuestionsIds,
  } = formViewModel;
  return {
    id,
    availableCountries,
    title,
    deletedQuestionsIds,
    questions: questions.map((q: any) => {
        [q.type] = q.type;
        [q.previewType] = q.questionPreview;
        q.options = q.questionOptions;
        if (q.previewType === QuestionPreviewType.SELF_SELECT) {
          q.options = q?.options?.length ? q?.options : [{}];
          q.options[0].text = q.title;
        }
        delete q.questionPreview;
        delete q.questionOptions;
        return q;
    }),
  };
}

export {
  facilityToDTO,
}